// extracted by mini-css-extract-plugin
export default {"messages_wrapper":"block-manager_messages_wrapper__fXfS5"};